import $ from "jquery"
global.jQuery = $;
window.jQuery = $;


export default {
  name: 'sub-menu',
  created () {
    this.initialization()
  },
  data () {
    return {
    }
  },
  computed: {
    profileImagePath () {
      return window.localStorage.getItem('profile_image_path') ? window.localStorage.getItem('profile_image_path') : ''
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    getRejectedCount() {
      return this.$store.getters.rejectedCount
    }
  },
  methods: {
    initialization: function () {
      var data = {
        'user_id': window.localStorage.getItem('user_id')
      }
      this.$store.dispatch('GET_REJECTED_COUNT', { data: data })
    },
    subMenuFix: function() {
      var $win = $(window)
      $win.on('load scroll', function() {
        var value = $(this).scrollTop()
        if ( value >= 59  ) {
          $(".submenu__list").addClass('gheader-fix')
          $(".wrapper").css('margin-top', 53)
        } else {
          $(".submenu__list").removeClass('gheader-fix')
          $(".wrapper").css('margin-top', 0)
        }
      })
    },
    goProposeAllshopList: function() {
      this.$router.push({ path: '/propose_allshop_list' })
      $(window).scrollTop(0)
    },
    goProposeNew: function() {
      this.$router.push({ path: '/propose/new' })
    },
    goProposeRejectedList: function() {
      this.$router.push({ path: '/propose_rejected_list' })
      $(window).scrollTop(0)
    },
    goProposePersonalList: function() {
      this.$router.push({ path: '/propose_personal_list/' + window.localStorage.getItem('user_id')})
      $(window).scrollTop(0)
    },
    shopOn: function() {
      if (this.$route.name == 'proposeMyshopList' ||
          this.$route.name == 'proposeAllshopList' ||
          this.$route.name == 'proposeSearchList' ||
          ((this.$route.name == 'proposePersonalList') && (this.$route.params.id != window.localStorage.getItem('user_id')))) {
        return '-on'
      } else {
        return ''
      }
    },
    userOn: function() {
      if ((this.$route.name == 'proposePersonalList') && (this.$route.params.id == window.localStorage.getItem('user_id'))) {
        return '-on'
      } else {
        return ''
      }
    },
    rejectedOn: function() {
      if (this.$route.name == 'proposeRejectedList') {
        return '-on'
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/sub-menu.js